var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Badge",class:_vm.variant ? `Badge--${_vm.variant}` : _vm.variant},[_vm._v(_vm._s(_vm.$t(_vm.value)))])
}
var staticRenderFns = []

export { render, staticRenderFns }